module.exports = __webpack_public_path__ + "media/bg/bg-1-e0c2a4f8.jpg";